<template>
  <v-card height="90%" width="97%" class="ma-3" flat>


    <v-card-title>

      <v-spacer>
      </v-spacer>
      <v-text-field v-model="search" label="Search by kiosk" single-line hide-details clearable @keyup.enter="fetchData(false)" @click:clear="fetchData(true)"></v-text-field>
      <!--<v-btn color="primary" @click="fetchData">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>-->
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="downloadExcel">
        <v-icon>mdi-download</v-icon>
      </v-btn>

    </v-card-title>

    <v-data-table fixed-header :headers="headers" :items="items" item-key="idVente" :options.sync="options" :server-items-length="totalItems"
      :items-per-page="itemsPerPage" :page="page" :footer-props="{
        'items-per-page': itemsPerPage,
        'page': page,
        'total-items': totalItems,
        'items-per-page-options': [5,50, 100, 150, { text: 'All', value: -1 }]
      }" @update:page="onPageChange" @update:items-per-page="onItemsPerPageChange" class="elevation-1">
      <template v-slot:[`item.poidsFinaux`]="{ item }">
        <v-btn @click="showPoidsFinaux = !showPoidsFinaux" color="primary" size="small">
          View details
        </v-btn>
        <v-list v-if="showPoidsFinaux">
          <v-list-item v-for="(entry, index) in item.poidsFinaux" :key="index" :value="index">
            <v-list-item-title>
              {{ entry }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.historiquePoidsMin`]="{ item }">
        <v-btn @click="showDetails = !showDetails" color="primary" size="small">
          View details
        </v-btn>
        <v-list v-if="showDetails">
          <v-list-item v-for="(entry, index) in item.historiquePoidsMin" :key="index" :value="index">
            <v-list-item-title>
              Poids: {{ entry.poids }} | Temps: {{ entry.temps }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.kiosk`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ item.kiosk }}
            </span>
          </template>
          <span>{{getKioskName(item.kiosk)}}</span>
        </v-tooltip>
      </template>


      <!-- <template v-slot:[`item.kiosk`]="{ item }">
        <v-tooltip bottom>
{{item.kiosk}}
          <span>{{item.kiosk}}</span>
        </v-tooltip>
      </template> -->

      <template v-slot:[`item.valideAlgo1`]="{ item }">
        <v-chip v-if="item.valideAlgo1 == true" color="green" text-color="white">
          {{ item.valideAlgo1 }}</v-chip>
        <v-chip v-else color="red" text-color="white">
          {{ item.valideAlgo1 }}</v-chip>
      </template>

      <template v-slot:[`item.valideAlgo2`]="{ item }">
        <v-chip v-if="item.valideAlgo2 == true" color="green" text-color="white">
          {{ item.valideAlgo2 }}</v-chip>
        <v-chip v-else color="red" text-color="white">
          {{ item.valideAlgo2 }}</v-chip>
      </template>



    </v-data-table>
  </v-card>
</template>

<script>
import { store } from "@/models/Store.js";
import * as XLSX from 'xlsx'; 

export default {
  data() {
    return {
      showDetails: false,
      showPoidsFinaux: false,
      search: "",
      headers: [
        { text: 'Id Ventes', value: 'idVente' },
        { text: 'Date', value: 'date' },
        { text: 'Kiosk', value: 'kiosk' },
        { text: 'Statut', value: 'statut' },
        { text: 'Message', value: 'message' },
        { text: 'Article', value: 'article' },
        { text: 'valideAlgo1', value: 'valideAlgo1' },
        { text: 'valideAlgo2', value: 'valideAlgo2' },
        { text: 'Porte fermé', value: 'porteFermee' },
        { text: 'Poids tar', value: 'poidsTar' },
        { text: 'Poids finaux', value: 'poidsFinaux' },
        { text: 'poidsMin', value: 'poidsMin' },
        { text: 'Nombre echec Com', value: 'nombreEchecCom' },
        { text: 'Temps entre ouverture et premier poids', value: 'tempsEntreOuvertureEtPremierPoids' },
        { text: 'Temps max entre deux poids min', value: 'temps max entre deux poids min' },
        { text: 'Temps moyen entre deux poids min', value: 'tempsMoyenEntreDeuxPoidsMin' },
        { text: 'Historique poids min', value: 'historiquePoidsMin' },
        { text: 'Confirmation Ouverture', value: 'confirmationOuverture' },
      ],
      items: [],
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      kiosksNames:[],
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: []
      }
    };
  },

  methods: {
    // Charger les données avec la pagination
    async fetchData(resetPage = false) {
      try {
        if (resetPage) {
          this.page = 1;
          this.itemsPerPage = 10;
          this.search = '';
          this.options.sortBy = [];
          this.options.sortDesc = [];
          this.items = [];
          this.totalItems = 0;
          this.totalPages = 0;
        }

        const { page, itemsPerPage, sortBy, sortDesc } = this.options

        //await store.getLogMonoCaseByPagination(this.page, this.itemsPerPage,this.search);

        await store.getLogMonoCaseByPagination(page, itemsPerPage,this.search, sortBy[0], sortDesc[0]);

        const response = store.state.log; // Récupère la réponse du store

        this.items = response.items;  // Liste des éléments pour la page courante
        this.totalItems = response.totalItems;  // Nombre total d'éléments
        this.totalPages = response.totalPages;  // Nombre total de pages
        this.page = response.currentPage; 

      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      }
    },

    // Gérer le changement de page
    onPageChange(newPage) {
      this.page = newPage;
      this.fetchData(false);
    },

    // Gérer le changement du nombre d'éléments par page
    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData(false);
    },

    downloadExcel() {
      // Préparer les données pour l'exportation
      const formattedData = this.items.map((item) => {
        return {
          kiosk: item.kiosk,
          date: item.date,
          idVente: item.idVente,
          statut: item.statut,
          message: item.message,
          article: item.article,
          valideAlgo1: item.valideAlgo1,
          valideAlgo2: item.valideAlgo2,
          porteFermee: item.porteFermee,
          poidsTar: item.poidsTar,
          poidsMin: item.poidsMin,
          poidsFinaux: item.poidsFinaux.join('| '), 
          nombreEchecCom: item.nombreEchecCom,
          tempsEntreOuvertureEtPremierPoids: item.tempsEntreOuvertureEtPremierPoids,
          tempsMaxEntreDeuxPoidsMin: item.tempsMaxEntreDeuxPoidsMin,
          tempsMoyenEntreDeuxPoidsMin: item.tempsMoyenEntreDeuxPoidsMin,
          historiquePoidsMin: item.historiquePoidsMin
            .map(entry => `Poids: ${entry.poids}| Temps: ${entry.temps}`)
            .join('; '), 
          confirmationOuverture: item.confirmationOuverture,
        };
      });

      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Données');

      XLSX.writeFile(wb, 'donnees.xlsx');
    },
    async getKiosksNames() {
      await store.getKiosksNames();
      this.kiosksNames = store.state.kiosksNames;
      console.log("this.kiosksNames.length" + this.kiosksNames.length);
    },
    getKioskName(value) {
      const kiosk = this.kiosksNames.find(k => k.idExtranet === value.toString());
      return kiosk ? kiosk.name : value;
    },
  },
  mounted() {
    console.log("mounteeed ===== ");
     this.getKiosksNames();
     this.fetchData(false); 
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.fetchData(false)
      }
    }
  }
};
</script>
